import { CompositionSlotDef } from 'types/composition';

/**
 * Normalizes a composition interface's `slots` (string shorthand or object form) to the object
 * form every conformance and schema-generation consumer reasons over, so neither has to branch
 * on shape. String entries default to `required: false` — today's authoring semantics.
 */
export function normalizeCompositionSlots(slots: ReadonlyArray<string | CompositionSlotDef> = []): CompositionSlotDef[] {
  return slots.map((slot) => (typeof slot === 'string' ? { name: slot, required: false } : { name: slot.name, required: slot.required ?? false }));
}
